import React from 'react'
import Popover from 'pcln-popover'
import { Box, Button, CloseButton, Flex, Text } from 'pcln-design-system'
import { reloadPage } from '../helpers'

const EditAttributesFilters = ({ children }) => {
  return (
    <Box>
      <Popover
        renderContent={({ handleClose }) => {
          const closePopover = (e) => {
            e.stopPropagation()
            handleClose()
          }
          return (
            <Box p={3}>
              <Flex align='flex-start'>
                <Text>Customizations are applied to all flights.</Text>
                <CloseButton onClick={closePopover} ml='auto' />
              </Flex>
              <Text>Confirming below will take you back to the first flight to change your preferences.</Text>
              <Flex justifyContent='right' mt={3}>
                <Button variation='subtle' onClick={closePopover} mr={2} size='small'>
                  Cancel
                </Button>
                <Button color='primary' size='small' onClick={() => reloadPage()}>
                  Confirm
                </Button>
              </Flex>
            </Box>
          )
        }}
        placement='bottom'
        ariaLabel='Edit Popover'
        idx={2}
        width={210}
        zIndex={1000}
      >
        <div>{children}</div>
      </Popover>
    </Box>
  )
}

EditAttributesFilters.displayName = 'EditAttributesFilters'

export { EditAttributesFilters }
